<div class="content" [ngClass]="getClauseClass(content?.clauseType)">
  <span class="index">{{ content?.index }}</span>
  <div class="clause">
    <span>{{ content.title }}</span>
  </div>
</div>
